import axios from 'axios';
import authConfig from '../auth_config.json';

class ClubService {
    domain = authConfig.domain;

    getPlaygrounds(date, slug) {

        return new Promise((resolve, reject) => {
            axios({url: this.domain+'player/playground/slots/'+slug+'/'+date, method: 'GET' })
                .then(resp => {
                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

}

const clubService = new ClubService();

export default clubService;
